import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M6 24H2a1 1 0 00-1 1v6a1 1 0 001 1h4a1 1 0 001-1v-6a1 1 0 00-1-1zm-1 6H3v-4h2v4zM14 20h-4a1 1 0 00-1 1v10a1 1 0 001 1h4a1 1 0 001-1V21a1 1 0 00-1-1zm-1 10h-2v-8h2v8zM22 12h-4a1 1 0 00-1 1v18a1 1 0 001 1h4a1 1 0 001-1V13a1 1 0 00-1-1zm-1 18h-2V14h2v16zM30 6h-4a1 1 0 00-1 1v24a1 1 0 001 1h4a1 1 0 001-1V7a1 1 0 00-1-1zm-1 24h-2V8h2v22zM22 0h-5v2h2.586L2.293 19.293l1.414 1.414L21 3.414V6h2V1a1 1 0 00-1-1z"></path>
        </svg>
    );
}